import { render } from "./StatementDetails.vue.ts?vue&type=template&id=ece66fb6&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./StatementDetails.vue?vue&type=template&id=ece66fb6&scoped=true&ts=true"
import script from "./StatementDetails.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./StatementDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatementDetails.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./StatementDetails.vue?vue&type=script&lang=ts&setup=true"

import "./StatementDetails.vue.scss?vue&type=style&index=0&id=ece66fb6&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./StatementDetails.vue?vue&type=style&index=0&id=ece66fb6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece66fb6"],['__file',"src/apps/credit-line/components/StatementDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ece66fb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ece66fb6', __exports__)) {
    api.reload('ece66fb6', __exports__)
  }
  
  module.hot.accept("./StatementDetails.vue.ts?vue&type=template&id=ece66fb6&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./StatementDetails.vue?vue&type=template&id=ece66fb6&scoped=true&ts=true", () => {
    api.rerender('ece66fb6', render)
  })

}


export default __exports__